// PURPOSE: Keep public scheduling links outside the authenticated application runtime.
// CONTRACT: Spec 056; public links skip sessions, private routing mounts after OIDC completion.
// DEPENDS: React Router, native App and PublicFindtimePage.
// CEILING: Public pages have no workspace API credentials.
import { BrowserRouter, Route, Routes, useParams } from 'react-router-dom';
import { SessionProvider } from './auth';
import App from './App';
import { PublicFindtimePage } from './findtime-public';
function PublicRoute() { const { token } = useParams(); return <PublicFindtimePage key={token} />; }
export function RuntimeRoutes() {
  // Auth completion replaces browser history before rendering its children. Preserve
  // that mount order so BrowserRouter reads the restored return URL, not /auth/callback.
  return location.pathname.startsWith('/f/')
    ? <BrowserRouter><Routes><Route path="/f/:token" element={<PublicRoute />} /><Route path="*" element={<main className="findtime-public">This event link is invalid.</main>} /></Routes></BrowserRouter>
    : <SessionProvider><BrowserRouter><App /></BrowserRouter></SessionProvider>;
}
